export default __webpack_public_path__ + "static/cercle_vicieux_de-fd5e347ac3ee36044efec75353890c66.mp4";